<style>
.avatar {
  border-radius: 5px;
}
</style>

<template>
  <v-menu
    offset-y
    left
    attach="#userMenuAnchor"
    content-class="app-menu flat-top-border elevation-1"
    :close-on-content-click="false"
    :nudge-width="200"
    v-model="menu"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon
           size="32"
          :color="nonProd ? 'white' : 'black'"
        >
          mdi-account-circle
        </v-icon>
      </v-btn>
    </template>
    <v-card class="flat-top-border">
      <v-row>
        <v-col cols="4" align="center">
          <v-icon size="90">mdi-account-circle</v-icon>
        </v-col>
        <v-col cols="8" dense>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title font-weight-regular">
                  {{ user.first_name }} {{ user.last_name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-divider></v-divider>
      <v-list>
        <v-list-item
          v-for="link in menuLinks"
          :key="link.icon"
          :href="link.to"
        >
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-weight-thin title">
              {{ link.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list>
        <v-list-item id="logout-btn" @click.stop="dialog = true">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-weight-thin title">Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-dialog
        v-model="dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="subtitle-1 font-weight-light">Are you sure you want to logout?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              id="cancel-logout-btn"
              color="info"
              text
              @click="dialog = false; menu = false;"
            >
              Go Back
            </v-btn>

            <v-btn
              id="confirm-logout-btn"
              color="error"
              text
              @click="logout"
            >
              Yes, log me out
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'UserMenu',
  props: {
    nonProd: Boolean,
    links: Array,
    user: {
      type: Object,
      default() {
        return {
          username: 'jonhdoe',
          first_name: 'Jon',
          last_name: 'Doe',
          email: 'user@email.com',
        };
      },
    },
    logoutMethod: Function,
  },
  data: () => ({
    dialog: false,
    menu: false,
  }),
  computed: {
    menuLinks() {
      if (this.links) { return this.links; }
      const arr = [{
        icon: 'mdi-cog',
        title: 'Account Settings',
        to: `${this.$servers.USERS}/#/settings/account`,
      }];

      if (this.user.permissions.includes('anchorapps:admin')) {
        arr.push({
          icon: 'mdi-shield-star',
          title: 'Administration Controls',
          to: `${this.$servers.USERS}/#/settings/admin?type=users`,
        });
      }

      return arr;
    },
  },
  methods: {
    logout() {
      this.dialog = false;
      this.menu = false;
      if (this.logoutMethod) {
        this.logoutMethod();
      } else {
        window.location = `${this.$servers.USERS}/logout`;
      }
    },
  },
  watch: {
    $route() {
      this.menu = false;
    },
  },
};
</script>
